import type { FaireProductEntity } from "../../entity_types/product";

export const p_r3zvv8xbeu: FaireProductEntity = {
  token: "p_r3zvv8xbeu",
  type: "product",
  name: "Green Onyx Dinosaur Carvings",
  brandToken: "b_ciwhgi8nfq",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/ecd55b6b3821a75962c476aac97ab1043f7c6127ebe4b1f88c63f423e7192c6e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a1ecd6f188bc19cf11460c9cd3ba710a5f101ddfc19db84256c44ee9727f9db7.jpeg",
    "https://cdn.faire.com/fastly/3a3b355474f1129c27c3df77d78f7c497d6f5985de3ccc500dcaa27ea028a191.jpeg",
    "https://cdn.faire.com/fastly/ea9106f6fffd508f07fa1794ff2ac9b589beeb4626b6c4c93a86e28df8307dda.jpeg",
    "https://cdn.faire.com/fastly/80584294ceb4aef4b784c64275756196da177f9105980f6e9d4ebac2eed3233e.jpeg",
    "https://cdn.faire.com/fastly/5b7c2554f93dc58753c80153eb440a24dd35dcd1884394e1a57dfc0591541c94.jpeg",
  ],
  priceDollars: 62.36,
  description:
    '🦕 Green Onyx Dinosaur Carvings 🦕\n\nThese green onyx dinosaur carvings combine bold prehistoric silhouettes with the layered beauty of natural green onyx. Polished to a smooth finish, each piece showcases flowing bands of soft mint to deeper emerald tones, giving every dinosaur its own distinct character.\n\nFun yet display-worthy, these carvings appeal to both crystal collectors and customers who love unique, giftable pieces.\n\nDino Details\n• "Dino" - SOLD\n• "Happy" - 6.25" tall\n• "Pebbles" - SOLD\n• "Bamm Bamm" - 3.75" tall\n\nProduct Details\n• Green onyx dinosaur carvings\n• Polished finish with smooth edges\n• Layered green banding with natural variation\n• Variety of dinosaur shapes and poses (depending on stock)\n• Each piece is unique in pattern and coloration\n• Ideal for display shelves, gift sections, and themed collections\n• Natural stone — variations are expected and embraced\n\nGreen onyx is often associated with growth and balance, while the dinosaur form adds a playful, eye-catching twist that draws attention in any retail setting.\n\nA standout addition for shops offering green onyx carvings, animal stone carvings, and distinctive wholesale pieces with personality and charm. 🦕',
  tags: [],
  msrpDollars: 124.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:23.212Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
